import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function BrandCard({ brand, count }) {
  return (
    <Link
      to={`/brand/${brand.slug}`}
      data-testid={`brand-card-${brand.slug}`}
      className="group relative flex flex-col justify-between overflow-hidden rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-slate-300 hover:shadow-[0_16px_36px_-22px_rgba(15,23,42,0.4)]"
    >
      <div className="flex items-start justify-between">
        <span className="font-heading text-2xl font-black tracking-tight text-slate-900">{brand.name}</span>
        {count != null && count > 0 && (
          <span className="rounded-sm bg-slate-100 px-2 py-0.5 font-mono text-[10px] font-semibold text-slate-500">{count}</span>
        )}
      </div>
      {brand.tagline && <p className="mt-2 text-sm text-slate-500">{brand.tagline}</p>}
      <span className="mt-5 inline-flex items-center gap-1 text-xs font-semibold text-sky-700">
        View equipment <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
      </span>
      <span className="thermo-bar pointer-events-none absolute bottom-0 left-0 h-0.5 w-0 transition-[width] duration-300 group-hover:w-full" />
    </Link>
  );
}
